import { render, staticRenderFns } from "./MyCkEditor.vue?vue&type=template&id=79da945d&scoped=true&"
import script from "./MyCkEditor.vue?vue&type=script&lang=js&"
export * from "./MyCkEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79da945d",
  null
  
)

export default component.exports